import React, {useEffect} from 'react';
import { Modal } from "@mui/material";
import Fade from '@mui/material/Fade';
import View from '@modul-connect/shared/components/atoms/view'
import { H1 } from '@modul-connect/shared/components/atoms/text'
import TextField from '@modul-connect/shared/components/molecules/textField'
import Button from '@modul-connect/shared/components/atoms/button';
import modal from '@modul-connect/shared/components/atoms/modal'

function isNumeric(value) {
  return !Number.isNaN(Number(value));
}

const ModalAddCode = ({
    openModal,
    onClose,
    addCode,
    disabled,
    onSubmit
}) => {
    const [code, setCode] = React.useState(null)
    const [errorCode, setErrorCode] = React.useState(false)
    const [description, setDescription] = React.useState('')
    const [errorDescription, setErrorDescription] = React.useState(false)

    useEffect(() => {
        if(openModal) {
            setCode(null)
            setDescription('')
            setErrorCode(false)
            setErrorDescription(false)
        }
    }, [openModal])

    const isName = (name) => {
      if(!name) return false
      if(!name.trim().length) return false
      
      return true
    }

    const onSave = () => {
        let hasErrors = false
        setErrorDescription(false)
        setErrorCode(false)

        if(!isName(description)) {
          setErrorDescription(true)
          hasErrors = true
        }

        if(!code || !isNumeric(code)) {
          setErrorCode(true)
          hasErrors = true
        }

        if(hasErrors) {
            return
        }

        const data = {
          code: Number(code),
          description: description
        }

        addCode(data)
        onSubmit(data)
        onClose()
    }

    return (
        <Modal
            open={ openModal }
            onClose={(event, reason) => {
              if (disabled && reason === 'backdropClick') {
                return
              }
              onClose()
            }}            
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
        >
            <Fade in={ openModal }>
                <div >
                    <View extend={ modal.container }>
                        <View extend={ modal.header }>
                            <H1 text={"Add Code"}/>
                        </View>
                        <View extend={{ ...modal.content, marginTop: '0'}}>
                            <TextField
                                name="Code*"
                                placeholder=""
                                disabled={ disabled }
                                error={errorCode}
                                onChange={e => setCode(e.target.value)}
                            />
                            <TextField
                                name="Description*"
                                placeholder=""
                                disabled={ disabled }
                                error={errorDescription}
                                onChange={e => setDescription(e.target.value)}
                            />
                        </View>
                        <View extend={ modal.footer }>
                            <Button noBg cancel disabled={ disabled } onClick={ () => onClose() }>
                                Cancel
                            </Button>
                            <Button noBg noPadding disabled={ disabled } onClick={ onSave }>
                                Submit
                            </Button>
                        </View>
                    </View>
                </div>
            </Fade>
        </Modal>
    )
}

export default ModalAddCode;